<template>
  <div class="container mescroll-touch">
    <div class="header">
      <div class="searchBox" @click="toSearch()">
        <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
        <span class="searchInput">请输入关键字搜索</span>
      </div>
      <div class="header_title">
        <div class="titleItem" :class="{'titleItem_active': tcode == item.TCode}" v-for="item in columnList" :key="item.Code" @click="changeTitleMenu(item.TCode)">
          <span>{{item.DisplayName}}</span>
        </div>
      </div>
    </div>

    <div class="mescrollBox">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <!-- <div class="menuBox">
          <span class="active">全部</span>
        </div> -->
        <div class="banner" v-if="bannerList.length > 0">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#CA001B">
            <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="imgclick(item.UrlLink)">
              <img class="bannerImg" :src="item.File_Url" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div class="titleBox">
          <div class="title">
            <img class="screenIcon" src="@/assets/images/new_home_icon_alt@2x.png" />
            <span>最新推荐</span>
          </div>
          <div class="more" @click="toList()">
            <span>更多</span>
            <img src="@/assets/images/more_yellow.png" />
          </div>
        </div>
        <div class="recommendBox">
          <div class="recommendItem" v-for="(item, index) in recommendList" :key="index" @click="toContentPage(item.Id, item.Type)">
            <div class="item_img">
              <img class="item_cover" :src="item.Thumbnail" />
              <img class="playIcon" v-if="item.Type == 1 || item.Type == 3" src="@/assets/images/play_comm_icon@2x.png" />
            </div>
            <div class="item_content">
              <span class="item_title">{{item.Title}}</span>
              <p class="item_time">{{item.yyyymmdd}}</p>
              <div class="item_nums">
                <div class="nums">
                  <img class="watchIcon" src="@/assets/images/watch_yellow.png" />
                  <span>{{item.WatchCount}}</span>
                </div>
                <div class="nums">
                  <img class="likeIcon" src="@/assets/images/like_yellow.png" />
                  <span>{{item.LikeCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="titleBox">
          <div class="title">
            <img class="screenIcon" src="@/assets/images/new_home_icon_alt@2x.png" />
            <span>最新上线</span>
          </div>
        </div>
        <div class="list" id="dataList">
          <div class="item" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
            <div class="item_img">
              <img class="item_cover" :src="item.Thumbnail" />
              <img class="playIcon" v-if="item.Type == 1 || item.Type == 3" src="@/assets/images/play_comm_icon@2x.png" />
            </div>
            <div class="item_content">
              <span class="item_title">{{item.Title}}</span>
              <div class="item_flexbox">
              <p class="item_time">{{item.yyyymmdd}}</p>
              <div class="item_nums">
                <div class="nums">
                  <img class="watchIcon" src="@/assets/images/watch_yellow.png" />
                  <span>{{item.WatchCount}}</span>
                </div>
                <div class="nums">
                  <img class="likeIcon" src="@/assets/images/like_yellow.png" />
                  <span>{{item.LikeCount}}</span>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </mescroll-vue>
    </div>
    <div class="goBackZone" v-if="entry == 'enteringZone'" @click="goBackZone">返回专区</div>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
  name: 'CNVZone',
  data() {
    return {
      bannerList: [],
      columnList: [],
      tcode: '',
      recommendList: [],
      list: [],
      PageIndex: 0,
      PageSize: 6,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata"></p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        }
			},
      entry: null
    }
  },
  components: {
    MescrollVue
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
  },
  watch: {
    tcode() {
      this.getRecommendList();
    }
  },
  created() {
    if(this.code) {
      this.getColumn();
      this.getBanner();
    }
    this.entry = sessionStorage.getItem("entry");
  },
  methods: {
    // 获取Banner
    getBanner() {
      this.$axios.get('/Api/api/Web/ImgFile/GetImgFileListByCode?Code=' + this.code).then(res => {
        this.bannerList = res.Data;
        if(this.bannerList.length > 0) {
          this.isBanner = true;
        }
      })
    },
    // 获取栏目
    getColumn() {
      this.$axios.get('/Api/api/Web/Article/GetCode?code=' + this.code).then(res => {
        let data = res.Data;
        if(data.length > 0) {
          this.tcode = data[0].TCode;
          this.getRecommendList();
        } else {
          this.showStayTuned = true;
        }
        this.columnList = data;
      })
    },
    // 获取最新推荐列表数据
    getRecommendList() {
      this.$axios.post('/Api/Api/Web/Article/GetArticleList', {
        SubjectTCode: this.tcode,
        ModuleType: 2,
        PageIndex: 1,
        PageSize: 2
      }).then((res) => {
        if(res.Data.List) {
          this.recommendList = res.Data.List;
        }
      }).catch((e) => {
      })
    },
    // 获取最新上线列表数据
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetArticleList', {
          SubjectTCode: this.tcode,
          ModuleType: 7,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then((res) => {
          let arr = [];
          if(res.Data.List) {
            arr = res.Data.List;
          }
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    changeTitleMenu(tcode) {
      this.tcode = tcode;
      // this.getRecommendList();
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    toSearch() {
      this.scrollTop = this.$refs.mescroll.$el.scrollTop;
      this.$router.push({
        path: 'search',
        query: {
          code: this.code
        }
      });
    },
    imgclick(UrlLink) {
      let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
      if(UrlLink) {
				if(objExp.test(UrlLink)) {
				  location.href = UrlLink;
				}else{
					this.$router.push(UrlLink)
				}
      }
    },
    toContentPage(Id, Type) {
      this.scrollTop = this.$refs.mescroll.$el.scrollTop;
      this.$router.push({
        path: 'contentPage',
        query: {
          id: Id,
          type: Type
        }
      });
    },
    toList() {
      this.$router.push({
        path: 'recommendList',
        query: {
          tcode: this.tcode
        }
      });
    },
    goBackZone() {
      this.$router.push('/enteringZone');
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-image: url('../../assets/images/header_bg2.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #F8F8F8;
  .header {
    padding: 15px 15px 10px;
    .searchBox {
      display: flex;
      align-items: center;
      flex: 1;
      height: 35px;
      line-height: 35px;
      border-radius: 35px;
      background-color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      padding: 0 15px;
      margin-bottom: 10px;
      .searchIcon {
        width: 15px;
        height: 15px;
      }
      .searchInput {
        flex: 1;
        margin-left: 8px;
        border: none;
        color: #999999;
      }
    }
    .header_title{
      display: flex;
      align-items: center;
      .titleItem {
        position: relative;
        padding: 0 10px;
        font-size: 15px;
        color: #FFFFFF;
        span {
          display: inline-block;
          width: 100%;
        }
      }
      .titleItem_active::after {
        content: "";
        position: absolute;
        left: 37%;
        width: 26%;
        height: 3px;
        border-radius: 3px;
        background-color: #FFFFFF;
        bottom: -7px;
      }
    }
  }
  .mescrollBox {
    position: fixed;
    width: 100%;
    top: 95px;
    bottom: 0;
    height: auto;
    border-radius: 12px 12px 0 0;
    background-color: #F8F8F8;
  }
  .mescroll {
    padding: 15px 15px 0;
    box-sizing: border-box;
  }
  .menuBox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    span {
      display: inline-block;
      min-width: 23%;
      padding: 0 15px;
      height: 28px;
      border-radius: 28px;
      text-align: center;
      line-height: 28px;
      background-color: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #CCCCCC;
      font-size: 14px;
      color: #666666;
      box-sizing: border-box;
    }
    .active {
      color: $themeColor;
      border: 1px solid $themeColor;
    }
  }
  .banner {
    margin-bottom: 15px;
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 8px 0px;
    overflow: hidden;
    .bannerImg {
      width: 100%;
      display: block;
      border-radius: 10px;
    }
  }
  .titleBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      width: auto;
      display: flex;
      align-items: center;
      height: 30px;
      border-radius: 30px;
      padding: 0 10px;
      box-sizing: border-box;
      font-size: 14px;
      background-color: $themeColor;
      color: #FFFFFF;
      img {
        display: block;
        width: 16px;
        height: 14px;
        margin-right: 4px;
      }
    }
    .more{
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $themeColor;
      img {
        width: 14px;
        height: 14px;
        margin-left: 4px;
      }
    }
  }
  .recommendBox {
    display: flex;
    margin-bottom: 10px;
    min-height: 50px;
    .recommendItem {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      width: calc(calc(100% / 2) - 5px);
      border-radius: 6px;
      background-color: #FFFFFF;
      overflow: hidden;
      .item_img {
        position: relative;
        .item_cover {
          display: block;
          width: 100%;
        }
        .playIcon {
          position: absolute;
          right: 12px;
          bottom: 12px;
          width: 30px;
          height: 30px;
        }
      }
      .item_content {
        padding: 5px 8px 8px;
        .item_title {
          height: 35px;
          font-size: 13px;
          line-height: 17px;
          color: #333333;
          overflow: hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;
          word-wrap: break-word;
        }
        .item_time {
          font-size: 12px;
          color: #999999;
          line-height: 24px;
        }
        .item_label {
          display: flex;
          flex-wrap: wrap;
          span {
            display: inline-block;
            height: 20px;
            line-height: 20px;
            border-radius: 2px;
            padding: 0 6px;
            margin-right: 6px;
            margin-bottom: 5px;
            background-color: rgba(255, 73, 98, 0.15);
            font-size: 11px;
            color: #CA001B;
          }
        }
        .item_nums {
          display: flex;
          justify-content: flex-end;
          .nums {
            display: flex;
            align-items: center;
            .watchIcon {
              width: 14px;
              margin: 0 2px 0 6px;
            }
            .likeIcon {
              width: 11px;
              margin: 0 2px 0 6px;
            }
            span {
              font-size: 11px;
              color: #666666;
            }
          }
        }
      }
    }
    .recommendItem:not(:last-child) {
      margin-right: 10px;
    }
  }
  .list {
    .item {
      position: relative;
      display: flex;
      background-color: #FFFFFF;
      border-radius: 6px;
      overflow: hidden;
      .item_img {
        width: 50%;
        position: relative;
        .item_cover {
          display: block;
          width: 100%;
        }
        .playIcon {
          position: absolute;
          right: 12px;
          bottom: 12px;
          width: 30px;
          height: 30px;
        }
      }
      .item_content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        width: 0;
        padding: 8px;
        box-sizing: border-box;
        .item_title {
          height: 35px;
          font-size: 13px;
          line-height: 17px;
          color: #333333;
          overflow: hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;
          word-wrap: break-word;
        }
        .item_time {
          font-size: 12px;
          color: #999999;
          line-height: 22px;
        }
        .item_nums {
          // position: absolute;
          // bottom: 8px;
          display: flex;
          justify-content: flex-start;
          .nums {
            display: flex;
            align-items: center;
            .watchIcon {
              width: 14px;
              margin: 0 2px 0 0;
            }
            .likeIcon {
              width: 11px;
              margin: 0 2px 0 6px;
            }
            span {
              font-size: 11px;
              color: #666666;
            }
          }
        }
      }
    }
    .item:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
</style>